/* Luniescence - prix du lot sur la fiche produit
   Quantite 2 : -5 %, quantite 3 et plus : -17 % (memes remises automatiques que le panier).
   Le prix de base est toujours celui de la variante selectionnee. */
(function () {
  var dataEl = document.getElementById('lum-variant-prices');
  if (!dataEl) return;
  var prices;
  try { prices = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var firstId = dataEl.getAttribute('data-selected');

  function tier(q) { return q >= 3 ? 0.17 : (q === 2 ? 0.05 : 0); }

  function money(cents) {
    var s = (cents / 100).toFixed(2).split('.');
    var ent = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return ent + ',' + s[1] + '€';
  }

  function root() { return document.querySelector('.product-details') || document; }

  function variantId() {
    var r = root();
    var forms = r.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      if ((forms[i].getAttribute('id') || '').indexOf('product-form-installment') === 0) continue;
      var inp = forms[i].querySelector('input[name="id"]');
      if (inp && inp.value && prices[inp.value] != null) return inp.value;
    }
    var qs = r.querySelector('quantity-selector-component[data-variant-id]');
    if (qs && prices[qs.dataset.variantId] != null) return qs.dataset.variantId;
    var u = new URLSearchParams(location.search).get('variant');
    if (u && prices[u] != null) return u;
    return firstId;
  }

  function qty() {
    var inp = root().querySelector('quantity-selector-component input[name="quantity"]');
    var q = inp ? parseInt(inp.value, 10) : 1;
    return isNaN(q) || q < 1 ? 1 : q;
  }

  function render() {
    var container = root().querySelector('product-price [ref="priceContainer"]');
    if (!container) return;
    var vid = variantId();
    var unit = prices[vid];
    if (unit == null) return;
    var q = qty();
    var state = vid + '|' + q;
    if (container.getAttribute('data-lum') === state) return;

    var pct = tier(q);
    var html;
    if (pct === 0) {
      html = '<span class="price"><bdi>' + money(unit) + '</bdi></span>';
    } else {
      var sub = unit * q;
      var disc = Math.round(sub * pct);
      html = '<span class="price lum-qp-new"><bdi>' + money(sub - disc) + '</bdi></span>' +
        '<s class="lum-qp-old"><bdi>' + money(sub) + '</bdi></s>' +
        '<span class="lum-qp-save">−' + money(disc) + '</span>';
    }
    container.innerHTML = html;
    container.setAttribute('data-lum', state);
  }

  function schedule() { setTimeout(render, 30); }
  document.addEventListener('click', schedule, true);
  document.addEventListener('input', schedule, true);
  document.addEventListener('change', schedule, true);
  setInterval(render, 300);
  render();
})();

/* Luniescence - bouton "Acheter maintenant" : ajoute au panier puis ouvre directement le paiement */
(function () {
  function root() { return document.querySelector('.product-details') || document; }
  function buyNow(btn) {
    var form = btn.closest('form');
    if (!form) return;
    var idInp = form.querySelector('input[name="id"]');
    if (!idInp || !idInp.value) return;
    var qInp = form.querySelector('input[name="quantity"]') ||
      root().querySelector('quantity-selector-component input[name="quantity"]');
    var q = qInp ? parseInt(qInp.value, 10) : 1;
    if (isNaN(q) || q < 1) q = 1;
    var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    fetch(base + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(idInp.value, 10), quantity: q }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add');
      window.location.href = base + 'checkout';
    }).catch(function () {
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
    });
  }
  function ensure() {
    var r = root();
    var wrap = r.querySelector('form[data-type="add-to-cart-form"] [ref="productFormButtons"]') ||
      r.querySelector('form[data-type="add-to-cart-form"] .product-form-buttons');
    if (!wrap) return;
    var btn = wrap.querySelector('.lum-buy-now');
    if (!btn) {
      btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'button lum-buy-now';
      btn.textContent = 'Acheter maintenant';
      btn.addEventListener('click', function (e) { e.preventDefault(); buyNow(btn); });
      wrap.appendChild(btn);
    } else if (btn !== wrap.lastElementChild) {
      wrap.appendChild(btn);
    }
    var add = wrap.querySelector('button[type="submit"][name="add"], button[name="add"]');
    if (btn.getAttribute('aria-busy') !== 'true') {
      var off = !!(add && add.disabled);
      btn.disabled = off;
      btn.hidden = off;
    }
  }
  ensure();
  setInterval(ensure, 400);
})();
